import React, { useEffect } from "react";

const MaintenanceFullscreenModal = ({
  show = false,
  title = "Sito in Manutenzione Programmata",
  message = "Stiamo effettuando degli aggiornamenti ai nostri sistemi per migliorare le prestazioni e i servizi offerti.",
  timeRange = "Dalle ore 20:00 alle ore 24:00 del 2 Ottobre",
}) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999999,
        background: "rgba(15, 23, 42, 0.65)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      }}
    >
      <style>
        {`
          @keyframes pulseGlow {
            0% { transform: scale(1); opacity: 0.9; }
            50% { transform: scale(1.04); opacity: 1; }
            100% { transform: scale(1); opacity: 0.9; }
          }
          @keyframes spinSlow {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>

      <div
        style={{
          maxWidth: "580px",
          width: "100%",
          background: "rgba(30, 41, 59, 0.85)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          borderRadius: "24px",
          border: "1px solid rgba(245, 158, 11, 0.35)",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.7), 0 0 35px 0 rgba(245, 158, 11, 0.15)",
          padding: "40px 32px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        {/* Icona Manutenzione Animata */}
        <div
          style={{
            width: "84px",
            height: "84px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, rgba(245, 158, 11, 0.25) 0%, rgba(217, 119, 6, 0.15) 100%)",
            border: "1px solid rgba(245, 158, 11, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 0 25px rgba(245, 158, 11, 0.3)",
            animation: "pulseGlow 3s ease-in-out infinite",
          }}
        >
          <svg
            width="42"
            height="42"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fbbf24"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </div>

        {/* Badge di stato */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "rgba(245, 158, 11, 0.15)",
            border: "1px solid rgba(245, 158, 11, 0.4)",
            padding: "5px 14px",
            borderRadius: "9999px",
            fontSize: "12px",
            fontWeight: "700",
            letterSpacing: "0.6px",
            textTransform: "uppercase",
            color: "#fbbf24",
          }}
        >
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#fbbf24",
              boxShadow: "0 0 8px #fbbf24",
            }}
          />
          <span>Intervento in Corso</span>
        </div>

        {/* Titolo Principale */}
        <h2
          style={{
            fontSize: "26px",
            fontWeight: "700",
            color: "#ffffff",
            margin: "0",
            letterSpacing: "-0.5px",
            lineHeight: "1.25",
          }}
        >
          {title}
        </h2>

        {/* Testo descrittivo */}
        <p
          style={{
            fontSize: "15px",
            lineHeight: "1.6",
            color: "#cbd5e1",
            margin: "0",
            maxWidth: "460px",
          }}
        >
          {message}
        </p>

        {/* Finestra oraria */}
        {timeRange && (
          <div
            style={{
              width: "100%",
              background: "rgba(15, 23, 42, 0.6)",
              border: "1px solid rgba(255, 255, 255, 0.08)",
              borderRadius: "14px",
              padding: "12px 18px",
              fontSize: "14px",
              color: "#e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#fbbf24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            <span style={{ fontWeight: "600" }}>{timeRange}</span>
          </div>
        )}

        {/* Box per ordini urgenti */}
        <div
          style={{
            width: "100%",
            background: "linear-gradient(135deg, rgba(239, 68, 68, 0.12) 0%, rgba(220, 38, 38, 0.06) 100%)",
            border: "1px solid rgba(239, 68, 68, 0.35)",
            borderRadius: "14px",
            padding: "14px 18px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "6px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
              fontSize: "13px",
              fontWeight: "700",
              color: "#f87171",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </svg>
            <span>Ordini Urgenti</span>
          </div>
          <span style={{ fontSize: "14px", color: "#e2e8f0" }}>
            Se devi trasmettere ordini urgenti, contattaci via email a:
          </span>
          <a
            href="mailto:info@dgaplanetshirt.com"
            style={{
              color: "#60a5fa",
              fontWeight: "700",
              fontSize: "15px",
              textDecoration: "underline",
              letterSpacing: "0.2px",
              transition: "color 0.2s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#93c5fd")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#60a5fa")}
          >
            info@dgaplanetshirt.com
          </a>
        </div>

        {/* Messaggio di scuse / rassicurazione */}
        <p
          style={{
            fontSize: "13px",
            color: "#94a3b8",
            margin: "0",
            fontStyle: "italic",
          }}
        >
          Ci scusiamo per il momentaneo disagio. Il sito tornerà accessibile non appena terminati i lavori.
        </p>
      </div>
    </div>
  );
};

export default MaintenanceFullscreenModal;
